import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Database, Calendar, Building, Bot, Headphones, Zap, CreditCard, Shield, TrendingUp } from 'lucide-react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'O que é o Unisales-CRM?',
      answer: 'O Unisales-CRM é uma solução completa para gestão de relacionamento com clientes, permitindo acompanhar interações, histórico de vendas e personalizar comunicações para aumentar fidelização e vendas.'
    },
    {
      question: 'Como o Unisales-Eventos ajuda na organização de eventos?',
      answer: 'O Unisales-Eventos oferece ferramentas avançadas para gerenciar inscrições, agendas, pagamentos e feedback em tempo real, tornando a organização de eventos mais eficiente e profissional.'
    },
    {
      question: 'Quais benefícios o Unisales-ERP traz para minha empresa?',
      answer: 'O Unisales-ERP integra todos os processos empresariais numa plataforma unificada, controlando inventário, finanças, RH e operações para otimizar produtividade e reduzir custos.'
    },
    {
      question: 'Como a IA do Unisales pode otimizar meus processos?',
      answer: 'A Unisales IA utiliza inteligência artificial para previsões, chatbots e análise de dados avançada, ajudando a tomar decisões melhores e automatizar processos.'
    },
    {
      question: 'A Olimars oferece suporte personalizado?',
      answer: 'Sim, nossa equipe de especialistas trabalha lado a lado com você para implementar soluções que se adaptam às suas necessidades específicas, garantindo resultados excepcionais.'
    },
    {
      question: 'Como posso integrar o Unisales com meus sistemas existentes?',
      answer: 'Nossas soluções são altamente compatíveis e oferecem APIs robustas para integração seamless com sistemas ERP, CRM e ferramentas de terceiros. Nossa equipe técnica auxilia no processo de migração.'
    },
    {
      question: 'Qual é o modelo de precificação?',
      answer: 'Oferecemos planos flexíveis baseados em número de usuários, funcionalidades e volume de dados. Há também opções de licenciamento perpétuo e pagamento por uso. Solicite uma proposta personalizada.'
    },
    {
      question: 'O suporte é 24/7?',
      answer: 'Sim, nosso suporte técnico está disponível 24 horas por dia, 7 dias por semana, através de chat, email e telefone. Para clientes premium, oferecemos gerente de conta dedicado.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gray-50">
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Perguntas Frequentes</h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Encontre respostas rápidas para as dúvidas mais comuns sobre nossas soluções Unisales e serviços da Olimars.
              </p>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="space-y-4">
                {faqs.map((faq, index) => (
                  <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                    <button
                      onClick={() => toggleFAQ(index)}
                      className="w-full text-left p-6 hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                    >
                      <div className="flex justify-between items-center">
                        <h3 className="text-xl font-semibold text-gray-800">{faq.question}</h3>
                        <span className={`transform transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                          ▼
                        </span>
                      </div>
                    </button>
                    <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center mt-16">
                <p className="text-gray-600 mb-4">Não encontrou a resposta que procurava?</p>
                <button className="bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition duration-300">
                  Contactar Suporte
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default FAQPage;
